import React from "react";

const Logo = ({ className = "", variant = "dark" }) => {
  const textColor = variant === "light" ? "#ffffff" : "#0B2545";
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <svg
        width="44"
        height="44"
        viewBox="0 0 44 44"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-label="Metal Solutions logo"
      >
        <defs>
          <linearGradient id="msGrad" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="#00A859" />
            <stop offset="100%" stopColor="#00874A" />
          </linearGradient>
        </defs>
        <rect x="1" y="1" width="42" height="42" rx="10" fill="url(#msGrad)" />
        {/* Stylized M letterform */}
        <path
          d="M10 32 V12 H15 L22 22 L29 12 H34 V32 H29 V20 L23 28 H21 L15 20 V32 Z"
          fill="#ffffff"
        />
        {/* Small bolt accent */}
        <circle cx="34.5" cy="32.5" r="2.5" fill="#0B2545" />
      </svg>
      <div className="flex flex-col leading-tight">
        <span
          className="font-extrabold tracking-tight text-[17px] uppercase"
          style={{ color: textColor, letterSpacing: "0.5px" }}
        >
          Metal Solutions
        </span>
        <span
          className="text-[10px] font-medium tracking-[2px] uppercase"
          style={{ color: variant === "light" ? "#9CA3AF" : "#6B7280" }}
        >
          S.R.L.
        </span>
      </div>
    </div>
  );
};

export default Logo;
